import { useQuery } from "@tanstack/react-query";
import { HookOptions } from "../../../extensions/sw/modules/stats/hooks";
import { MatchFilter } from "../../../libs/statsFilters";
import { WorkerQueryOptions } from "../../../libs/workers/types";
import { GlobalStatsSelection } from "../../../types/stats";
import { getEntries } from "./CityEscapeTrendsOverTimeChart.service";
import { AggregationKeyInput } from "./CityEscapeTrendsOverTimeChart.types";
import { TrendsOverChartEntry } from "../../../components/TrendOverTimeChart/TrendsOverTimeChart.types";

export function useCityEscapeTrendsOverTimeChartEntries(
  data: {
    selection?: GlobalStatsSelection;
    dataType?: "cityEscape" | "product";
    filters?: MatchFilter;
    aggregationKey?: string;
    aggregationKeys?: AggregationKeyInput[]
    yAxisId?: string;
    opts?: WorkerQueryOptions;
  },
  opts?: HookOptions<any>
) {
  return useQuery<TrendsOverChartEntry[] | ArrayBufferLike | null>({
    queryKey: [
      "CityEscapeTrendsOverTimeChartEntries",
      JSON.stringify(data.selection),
      data.dataType,
      data.aggregationKey,
      JSON.stringify(data.aggregationKeys),
      JSON.stringify(data.filters),
      JSON.stringify(data.opts),
    ],
    queryFn: async () => await getEntries(data),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    gcTime: Infinity,
    ...opts,
  });
}
